export const cloneArray = <T>(array: T[]) => array.map((item) => item);

export const uniqueArray = <T>(array: T[]) => array.filter((item, position) => array.indexOf(item) === position);
